import {ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {FormArray, FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatExpansionPanel, MatExpansionPanelHeader} from '@angular/material/expansion';
import {IndexEntityService, IndicatorService, ReferenceListDto, ReferenceService} from '../../../apiModule1';
import {MultiSelect3Component} from '../../../../shared/components/multi-select3/multi-select3.component';
import {ChoiseComponent} from '../../../../shared/components/choise/choise.component';
import {FormulaConstructorComponent} from '../formula-constructor/formula-constructor.component';
import {filter, map} from 'rxjs/operators';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {CommunicationService} from '../../../../core/services/communication.service';
import {from, mergeMap, toArray} from "rxjs";

export const implementers: Implementer[] = [
  {id: 0, name: 'Organization', label: 'Учреждение'},
  {id: 1, name: 'Department', label: 'Структурное подразделение'},
]

export type Implementer = { id: number, name: ImplementerType, label: string }

@Component({
  standalone: true,
  selector: 'pas-dialog-indicators',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss', '../../index-entity/dialog/dialog.component.scss', '../../index-entity/filling-method/filling-method.component.scss'],
  imports: [
    MatFormField,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIcon,
    MatIconButton,
    MatButton,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MultiSelect3Component,
    ChoiseComponent,
    FormulaConstructorComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogComponent implements OnInit {

  isNew: boolean = false;

  implementerType = implementers;
  cbTypes: ReferenceListDto[] = [];

  indexItems: IndexItem[] = [] as IndexItem[];

  form = this.formBuilder.group({
    name: new FormControl<string>('', [Validators.required]),
    shortName: new FormControl<string>('', [Validators.required]),
    weight: new FormControl<number | null>(null, [Validators.required]),
    period: new FormControl<CriterionPeriod | null>(null, [Validators.required]),
    indexes: new FormControl<IndexEntry[] | null>(null, [Validators.required]),
    cb: this.formBuilder.array<(boolean | null)[]>([]),
    implementerType: new FormControl<{ id: number, name: ImplementerType }>(this.implementerType[0]),
    formula: new FormControl<string>(this.data['formula']),
    pointFormula: new FormControl<string>(this.data['pointFormula'])
  })

  get cbs() {
    return this.form.get('cb') as FormArray;
  }

  get everyItemsIsFalse(): boolean {
    return this.form.get('cb')!.value.every(x => x === false);
  }

  get indexesControl() {
    return this.form.get('indexes')!.value;
  }

  isEnabled: boolean = false;
  periods: CriterionPeriod[] = []


  indicator: Indicator = {} as Indicator;
  public indexes: IndexEntry[] = [];


  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Record<string, any>,
    private referenceService: ReferenceService,
    public dataService: IndicatorService,
    public indexService: IndexEntityService,
    private destroyRef: DestroyRef,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private commonService: CommunicationService,
  ) {
    this.isNew = data['isNew'];

    this.referenceService.apiReferencePeriodsGet().subscribe(({values}: { values: CriterionPeriod[] }) => {
      this.periods = values;
    })


    this.referenceService.apiReferencePeriodsGet().subscribe(({values}: { values: CriterionPeriod[] }) => {
      this.periods = values;
    })
  }


  _findFillTypeByName(name: string) {
    return this.implementerType.find(x => x.name === name);
  }

  _convertCBTypesToBoolean(cbTypes: ReferenceListDto[]): void {
      const controls = this.cbTypes
        .map((x: ReferenceListDto) => new FormControl(!!cbTypes.find(y => {
          const res = y.code === x.code;
          return res;
        })));
      this.form.setControl('cb', new FormArray(controls));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onApply() {
    if (this.form.invalid) return;
    const returnData: Indicator = {
      id: this.data['id'] || 0,
      name: this.form.get('name')!.value || '',
      weight: this.form.get('weight')!.value || 0,
      period: this.form.get('period')!.value || {id: 0, name: 'Годовая'} as CriterionPeriod,
      status: this.data['status'],
      cbTypes: this.cbTypes.filter((e: ReferenceListDto, i: number) => this.form.get('cb')!.value[i]),
      indexes: this.form.get('indexes')!.value || [],
      shortName: this.form.get('shortName')!.value || '',
      implementerType: this.form.get('implementerType')!.value?.name || this.implementerType[0].name,
      indexCount: this.form.get('indexes')!.value?.length || 0,
      formula: this.form.get('formula')!.value || '',
      pointFormula: this.form.get('pointFormula')!.value || ''
    }
    this.dialogRef.close(returnData);
  }

  // changePeriod(criterionPeriod: CriterionPeriod): void {
  //   this.form.get('period')!.setValue(criterionPeriod);
  // }

  ngOnInit() {
    this.form.get('indexes')?.valueChanges.subscribe((v: IndexEntry[] | null) => {
      if (!v) return;
      const listSelectes = v.filter((x: IndexEntry) => x.fillType === 'List_Select');
      const listSelectesIds = listSelectes.map(x => x.id);
      console.log(listSelectesIds);
      from(listSelectesIds).pipe(
        mergeMap(id => this.indexService.apiIndexIdGet({id})),
        filter(Boolean),
        toArray(),
        takeUntilDestroyed(this.destroyRef),
      ).subscribe({
        next: (indexesData: IndexEntry[]) => {
          this.indexItems = (indexesData.flatMap((x: IndexEntry) => x.indexItems) as IndexItem[]);
          this.cdr.markForCheck();
          },
          error: (err) => {
          console.error('Ошибка при загрузке объектов:', err);
        },
      })
    })

    this.form.statusChanges.subscribe(value => {
      console.log(value,this.form.get('cb')!.value, this.form.get('cb')!.status );
    })

    this.indexService.apiIndexGet({}).subscribe(({values}: { values: any }) => {
      this.indexes = values;
    })
    this.referenceService.apiReferenceCbtypesGet()
      .pipe(map(x => x.values))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(v => {
        this.cbTypes = v || []

        const controls = this.cbTypes.map(_ => new FormControl(false));
        this.form.setControl('cb', new FormArray(controls));


        if (!this.isNew) {
          this.dataService.apiIndicatorIdGet({id: this.data['id']}).subscribe((indicator: Indicator) => {
            if (!indicator) return;
            indicator.name && this.form.get('name')!.setValue(indicator.name);
            indicator.shortName && this.form.get('shortName')!.setValue(indicator.shortName);
            indicator.weight && this.form.get('weight')!.setValue(indicator.weight);
            indicator.period && this.form.get('period')!.setValue(indicator.period);
            indicator.indexes && this.form.get('indexes')!.setValue(indicator.indexes);
            indicator.cbTypes && this._convertCBTypesToBoolean(indicator.cbTypes);
            indicator.implementerType && this.form.get('implementerType')!.setValue(this._findFillTypeByName(indicator.implementerType) || this.implementerType[0]);
            indicator.formula && this.form.get('formula')!.setValue(indicator.formula);
          })
        }

        this.cdr.detectChanges()
      })
  }


  hasCbType(i: number): boolean {
    return !!this.form.get('cb')!.value[i];
  }

  async saveToClipboard(name: string) {
    await window.navigator.clipboard.writeText(name);
    this.commonService.publish('Скопировано в буфер обмена',{type:'info'});
  }
}

